import { SEARCH_DEALERS_URL } from "@/utils/api/Urls";
import axios from "axios";

interface InstallerSearchRequest {
  address?: string;
  latitude?: number;
  longitude?: number;
  radiusKm: number;
  sortBy?: string;
}

/**
 * Search dealers  from the server based on the provided address or coordinates.
 * @param address
 * @param coordinates
 * @param sortBy
 * @returns dealers
 */
export const searchDealers = async (address: string, coordinates?: { latitude: number; longitude: number }, sortBy?: string) => {
  console.log('searchDealers called with:', { address, coordinates, sortBy });
  const requestURL = `${SEARCH_DEALERS_URL}`;
  const requestData: InstallerSearchRequest = {
    address: address,
    radiusKm: 80,
    ...(coordinates && { latitude: coordinates.latitude, longitude: coordinates.longitude }),
    ...(sortBy && { sortBy: sortBy })
  };

  try {
    const response = await axios.post(requestURL, requestData);
    return response.data;
  } catch (err: unknown) {
    if (axios.isAxiosError(err)) {
      if (err.response) {
        console.log("Error status:", err.response.status);
        return;
      }

      if (err.request) {
        console.log("No response received from server:", err.request);
        return;
      }
    }
    console.log("Error occurred:", err);
  }
}; 